import { ScrollView } from "react-native";

// See NestedHScrollView.tsx.
export const NestedHScrollView = ScrollView;
